<template>
  <ckeditor :editor="editor.editor" v-model="value" :config="editor.editorConfig"></ckeditor>
</template>

<script>

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditorUploadAdapterPlugin from "@/core/plugins/CKEditorUploadFileAdapter";

export default {
  props: ['value', 'errors'],

  data() {
    return {
      editor: {
        editor: ClassicEditor,
        editorConfig: {
            language: 'fa',
            contentsLangDirection : 'rtl',
          extraPlugins: [CKEditorUploadAdapterPlugin],
        }
      },
      input: this.value,
    }
  },
  name: "siteSelect",
  watch : {
    input(){
      this.$emit('input', this.input)
    }
  }
}
</script>

<style scoped>
.ck.ck-editor__editable_inline[dir=ltr] {
  text-align: right !important;
  direction: rtl;
  border: 1px solid #cbcbcb;
  background: #fff;
  min-height: 300px;
}
</style>